import { Window } from '@execonline-inc/browser-window.private';
import clsx from 'clsx';
import * as React from 'react';
import { useState } from 'react';
import { Task } from 'taskarian';
import { AppyError, request, retryOnSessionExpiration } from '../../Appy';
import { currentUserStore } from '../../CurrentUserStore';
import { MissingLinkError, findLinkT } from '../../LinkyLinky';
import { Link } from '../../Resource/Types';
import { T } from '../../Translations';

type State = { kind: 'idle' } | { kind: 'stopping' };

// A full page load drops every store that still holds the impersonated user's data.
const goHome = (): void => {
  Window.redirect('/');
};

const stopImpersonating = (setState: (state: State) => void) => (): void => {
  setState({ kind: 'stopping' });
  Task.succeed<MissingLinkError | AppyError, ReadonlyArray<Link>>(currentUserStore.links)
    .andThen(findLinkT('logout'))
    .andThen((link) => retryOnSessionExpiration(request(link, {})))
    .fork(goHome, goHome);
};

const StopImpersonatingButton: React.FC = () => {
  const [state, setState] = useState<State>({ kind: 'idle' });

  return (
    <button
      type="button"
      onClick={stopImpersonating(setState)}
      disabled={state.kind === 'stopping'}
      className={clsx(
        'rounded-md border border-solid border-primary bg-card px-3 py-1 text-primary',
        'hover:bg-primary/10 disabled:opacity-50',
      )}
      data-intercom-target="stop-impersonating-button"
    >
      {state.kind === 'stopping' ? <T kind="Stopping…" /> : <T kind="Stop Impersonating" />}
    </button>
  );
};

export default StopImpersonatingButton;
